export let ConversationState;
(function (ConversationState) {
  ConversationState[ConversationState["Prechat"] = 0] = "Prechat";
  ConversationState[ConversationState["Loading"] = 1] = "Loading";
  ConversationState[ConversationState["ReconnectChat"] = 2] = "ReconnectChat";
  ConversationState[ConversationState["OutOfOffice"] = 3] = "OutOfOffice";
  ConversationState[ConversationState["ProactiveChat"] = 4] = "ProactiveChat";
  ConversationState[ConversationState["Active"] = 5] = "Active";
  ConversationState[ConversationState["InActive"] = 6] = "InActive";
  ConversationState[ConversationState["PostchatLoading"] = 7] = "PostchatLoading";
  ConversationState[ConversationState["Postchat"] = 8] = "Postchat";
  ConversationState[ConversationState["Closed"] = 9] = "Closed";
  ConversationState[ConversationState["Error"] = 10] = "Error";
})(ConversationState || (ConversationState = {}));